<button
  type="button"
  class="sigd-notifications-bell__trigger"
  [class.sigd-notifications-bell__trigger--sections]="variant() === 'sections'"
  [class.sigd-notifications-bell__trigger--topbar]="variant() === 'topbar'"
  (click)="togglePanel($event)"
  aria-label="Notificaciones"
  [attr.aria-expanded]="panelOpen()"
>
  <i class="pi pi-bell" aria-hidden="true"></i>
  @if (unreadBadge(); as badge) {
    <span class="sigd-notifications-bell__badge" aria-hidden="true">{{ badge }}</span>
  }
</button>

<p-overlayPanel #panel styleClass="sigd-notifications-bell__panel" [showCloseIcon]="true">
  <div class="sigd-notifications-bell__header">
    <div>
      <h2 class="sigd-notifications-bell__title">Notificaciones</h2>
      @if (store.unread() > 0) {
        <p class="sigd-notifications-bell__subtitle">{{ store.unread() }} sin leer</p>
      }
    </div>
    @if (store.unread() > 0) {
      <button type="button" class="sigd-notifications-bell__mark-all" (click)="markAllRead($event)">
        Marcar todas leídas
      </button>
    }
  </div>

  @if (store.loading() && !store.loaded()) {
    <p class="sigd-notifications-bell__empty">Cargando…</p>
  } @else if (store.error()) {
    <p class="sigd-notifications-bell__empty sigd-notifications-bell__empty--error" role="alert">
      {{ store.error() }}
    </p>
  } @else if (previewItems().length === 0) {
    <p class="sigd-notifications-bell__empty">No tenés notificaciones sin leer.</p>
  } @else {
    <ul class="sigd-notifications-bell__list">
      @for (item of previewItems(); track item.id) {
        <li>
          <button
            type="button"
            class="sigd-notifications-bell__item"
            [class.is-unread]="!item.read"
            (click)="openNotification($event, item)"
          >
            <span class="sigd-notifications-bell__item-head">
              <i [class]="iconForKind(item.kind)" aria-hidden="true"></i>
              <span class="sigd-notifications-bell__item-kind">{{ labelForKind(item.kind) }}</span>
              <span class="sigd-notifications-bell__item-time">{{ relativeTime(item.createdAt) }}</span>
            </span>
            <span class="sigd-notifications-bell__item-title">{{ item.title }}</span>
            @if (item.message) {
              <span class="sigd-notifications-bell__item-body">{{ item.message }}</span>
            }
          </button>
        </li>
      }
    </ul>
  }

  <button type="button" class="sigd-notifications-bell__footer" (click)="openInbox()">
    Ver todas
  </button>
</p-overlayPanel>
